exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[role=dialog] .el-message-box__content .el-form>div[data-v-264d3a59]:last-of-type{text-align:left}[role=dialog] .el-message-box__content .el-form>div[data-v-264d3a59]:last-of-type{margin:0}.input-new-tag[data-v-264d3a59]{width:90px;margin-left:10px;vertical-align:bottom}.footer[data-v-264d3a59]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
